<template functional>
  <i :class="`country-${props.country}`" @mouseover="props.tooltipCallback({ text: props.tooltip, event: $event })" />
</template>

<script>
export default {
  name: 'Flag',
  props: {
    country: {
      type: String,
      required: false,
      default: 'jp',
    },
    tooltip: {
      type: String,
      required: false,
      default: 'tracking: google.co.jp - language: ja',
    },
    tooltipCallback: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
};
</script>
